module.exports = __webpack_public_path__ + "static/media/fold-window-tool.214f8f11.png";